import { render } from "./topics.html?vue&type=template&id=5ecaee78&external"
import script from "./topics.js?vue&type=script&lang=js&external"
export * from "./topics.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__